var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Vue, Component, Watch, Ref } from "vue-facing-decorator";
import { Feature, SystemTrendClient, LookupsClient, GetSystemTrendChartQuery, GetBlockPredictionQuery, GetSystemTrendChartQueryModel, TimeseriesChart, Dataset, GetSystemTrendChartLimitQueryModel, MeasurementDataSourceEnum, GetTrendPDFReportQuery, MeasurementTypeEnum, Annotation, AnnotationFont } from "@/app/api/battery-portal-api";
import { SelectableDatasetModel } from "@/app/models/selectable-dataset.model";
import { ScaleRangeModel } from "@/app//models/scale-range.model";
import VerticalSplitterVue from "@/app/vues/components/vertical-splitter.vue";
import TrendGraphVue from "@/app/vues/charts/trend-graph.vue";
import TrendGraphFilterVue from "@/app/vues/charts/trend-graph-filter.vue";
import { Notifier } from "@//common/utils/notifier";
import { DateHelper } from "@/app/utils/date-helper";
import { HttpHelper } from "@/app/utils/http-helper";
import { ArrayHelper } from "@/app/utils/array-helper";
import { MeasurementHelper } from "@/app/utils/measurement-helper";
import { DownloadUtil } from "@/app/utils/download-util";
import { State } from "vuex-facing-decorator";
import { LoginState } from "@/app/store/modules/login.state";
import QueryStringHelper from "@/app/utils/querystring-helper";
import store from "@/app/store/store";
import moment from "moment";
import pako from 'pako';
const systemTrendClient = new SystemTrendClient(window.apiUrl);
const lookupsClient = new LookupsClient(window.apiUrl);
const queryStringHelper = new QueryStringHelper();
let TrendVue = class TrendVue extends Vue {
    constructor() {
        super(...arguments);
        this.defaultLineWidth = 1;
        this.defaultPointRadius = 3;
        this.useImperialMeasurementSystem = store.getters["loginModule/isUsingImperialMeasurementSystem"];
        // simpletons
        this.working = false;
        this.chartLoaded = false;
        this.selectedAxis = 0;
        this.componentKey = 0;
        this.searchAttempted = false;
        this.showExtrapolateButton = false;
        this.disableExtrapolateButton = true;
        this.blockIdsExtrapoleted = [];
        // chart behavior flags
        this.animate = true;
        this.autoScale = true;
        this.plotLeftAxis = false;
        this.plotRightAxis = false;
        this.syncAxes = false;
        this.showDataPoints = false;
        this.customLeftAxisMinValue = null;
        this.customLeftAxisMaxValue = null;
        this.customRightAxisMinValue = null;
        this.customRightAxisMaxValue = null;
        this.chartLegendPinned = false;
        this.chartLegendVisible = false;
        this.chartLegendPinButtonVisible = true;
        this.chartOptions = {
            fill: false,
            maintainAspectRatio: false,
            throttle: 100,
            layout: {
                padding: {
                    right: this.getChartPaddingLeft()
                }
            },
            scales: this.constructScales(),
            plugins: {
                legend: {
                    display: false
                },
                zoom: {
                    zoom: {
                        wheel: {
                            enabled: true,
                        },
                        drag: {
                            enabled: true,
                            borderColor: 'rgb(54, 162, 235)',
                            borderWidth: 1,
                            backgroundColor: 'rgba(54, 162, 235, 0.3)',
                            threshold: 5
                        },
                        mode: 'xy',
                        scaleMode: 'xy',
                        onZoomComplete: this.saveChartQueryString
                    },
                    pan: {
                        enabled: true,
                        mode: "xy",
                        modifierKey: 'ctrl',
                        onPanComplete: this.saveChartQueryString
                    }
                },
                tooltip: {
                    callbacks: {
                        title: (tooltipItems) => {
                            let tooltipItem = tooltipItems[0];
                            if (!tooltipItem)
                                return "";
                            return DateHelper.formatString(`${tooltipItem.label}`);
                        },
                        label: (tooltipItem) => {
                            let label = tooltipItem.dataset.label || "";
                            if (label)
                                label = `${label}: `;
                            if (tooltipItem.parsed.y !== null) {
                                var formattedValue = MeasurementHelper.getFormattedValueForUnitOfMeasurement(tooltipItem.parsed.y, tooltipItem.dataset.measurementTypeId);
                                label += `${formattedValue} ${tooltipItem.dataset.unitOfMeasurement}`;
                            }
                            return label;
                        }
                    }
                }
            }
        };
        // models
        this.chartData = new TimeseriesChart();
        this.axes = new Array();
        this.query = new GetSystemTrendChartQuery({
            forFeature: Feature.TrendGraph,
            timezoneOffset: moment().utcOffset(),
            axes: [
                new GetSystemTrendChartQueryModel({
                    systemId: 0,
                    companyId: 0,
                    measurementTypeId: 0,
                    measurementTypeName: null,
                    startTime: null,
                    endTime: null,
                    limitQuery: new GetSystemTrendChartLimitQueryModel({
                        nodeId: 0,
                        stringStatusId: 0
                    }),
                    dataSource: MeasurementDataSourceEnum.Snapshot
                }),
                new GetSystemTrendChartQueryModel({
                    systemId: 0,
                    companyId: 0,
                    measurementTypeId: 0,
                    measurementTypeName: null,
                    startTime: null,
                    endTime: null,
                    limitQuery: new GetSystemTrendChartLimitQueryModel({
                        nodeId: 0,
                        stringStatusId: 0
                    }),
                    dataSource: MeasurementDataSourceEnum.Snapshot
                })
            ]
        });
        this.proxyQuery = new GetSystemTrendChartQuery();
        this.chartLegend = [];
        this.scaleRanges = [];
        this.highlightedDataSetId = null;
        this.stringStates = [];
    }
    created() {
        this.getStringStates();
        this.proxyQuery.init(this.query);
    }
    ;
    mounted() {
    }
    ;
    search() {
        if (this.working)
            return;
        return new Promise(resolve => {
            var _a;
            let query = this.searchQuery();
            this.showExtrapolateButton = ((_a = query.axes) === null || _a === void 0 ? void 0 : _a.findIndex(x => x.measurementTypeId == MeasurementTypeEnum.Ohmic)) >= 0;
            this.saveQueryString(query);
            this.working = true;
            systemTrendClient
                .getSystemTrendChart(query)
                .then(response => {
                this.chartData = response || new TimeseriesChart();
                this.chartOptions.scales = this.constructScales();
                this.chartOptions.layout.padding.right = this.getChartPaddingLeft();
                this.blockIdsExtrapoleted = [];
                this.disableExtrapolateButton = true;
                this.highlightedDataSetId = null;
                // if there's a very small number of data points, show markers by default
                if (this.chartData.showMarkers)
                    this.showDataPoints = this.chartData.showMarkers;
                this.showOrHideDataPoints();
                this.chartLoaded = true;
                if (this.chartData.datasets && this.plotRightAxis)
                    this.chartData.datasets.forEach(item => {
                        if (item.yAxisID == "y-right")
                            item.borderDash = [10, 10];
                    });
                // set min / max values based on dataset.
                this.customLeftAxisMinValue = this.customRightAxisMinValue = this.chartData.minValue || 0;
                this.customLeftAxisMaxValue = this.customRightAxisMaxValue = this.chartData.maxValue || 0;
                this.constructChartLegend();
                this.forceRerender();
            })
                .then(() => resolve())
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
                this.animate = true;
            });
        });
    }
    ;
    print() {
        window.print();
    }
    ;
    exportToCSV() {
        if (!this.chartData.measurements || !this.chartData.measurements[0].measurements) {
            Notifier.onWarning("Please create a chart before downloading data.");
            return;
        }
        let query = this.searchQuery();
        query.currentTimezoneOffset = moment().utcOffset();
        this.working = true;
        systemTrendClient.downloadSystemTrendChartAsCsv(query)
            .then(response => {
            if (!response) {
                Notifier.onWarning("Could not download chart data.");
                return;
            }
            DownloadUtil.handleFileDownload(response);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    selectAxis(index) {
        this.selectedAxis = index;
        if (!index || !this.query.axes)
            return;
        let axisAddedToChart = this.proxyQuery
            && this.proxyQuery.axes
            && this.proxyQuery.axes[index]
            && this.proxyQuery.axes[index].systemId ? true : false;
        if (axisAddedToChart)
            return;
        let leftAxis = this.query.axes[0];
        let rightAxis = this.query.axes[index];
        if (!leftAxis || !rightAxis)
            return;
        rightAxis.systemId = leftAxis.systemId;
        rightAxis.companyId = leftAxis.companyId;
        rightAxis.startTime = leftAxis.startTime;
        rightAxis.endTime = leftAxis.endTime;
    }
    ;
    clearChart() {
        this.chartData = new TimeseriesChart();
        this.chartOptions.scales = this.constructScales();
        this.forceRerender();
    }
    ;
    forceRerender() {
        this.componentKey += 1;
    }
    ;
    plot(index) {
        this.searchAttempted = true;
        let validation = this.checkIfQueryIsValid(index);
        if (!validation.isValid) {
            Notifier.onWarning(validation.errorMessage ? validation.errorMessage : "Please review your selection for missing or invalid fields.");
            return;
        }
        if (!this.query.axes)
            return;
        if (!this.proxyQuery.axes)
            this.proxyQuery.axes = [];
        if (!index)
            this.plotLeftAxis = true;
        else
            this.plotRightAxis = true;
        // Prevent auto-suggest from recalculating during plot
        if (this.filters && this.filters[index]) {
            const filter = this.filters[index];
            if (filter && filter.setPlotting) {
                filter.setPlotting(true);
            }
        }
        let axis = new GetSystemTrendChartQueryModel();
        axis.init(this.query.axes[index]);
        this.proxyQuery.axes[index] = axis;
        this.search();
        // Re-enable auto-suggest after plot completes
        setTimeout(() => {
            if (this.filters && this.filters[index]) {
                const filter = this.filters[index];
                if (filter && filter.setPlotting) {
                    filter.setPlotting(false);
                }
            }
        }, 100);
    }
    ;
    removePlot(index) {
        if ((!index && !this.plotLeftAxis) || (index && !this.plotRightAxis))
            return;
        if (!index)
            this.plotLeftAxis = false;
        else
            this.plotRightAxis = false;
        if (!this.proxyQuery.axes)
            return;
        this.proxyQuery.axes[index].nodes = [];
        if (!this.plotLeftAxis && !this.plotRightAxis)
            this.clearChart();
        else
            this.search();
    }
    ;
    removeSelected() {
        this.removePlot(this.selectedAxis);
    }
    ;
    resetChart() {
        this.autoScale = true;
        this.searchAttempted = false;
        this.plotLeftAxis = false;
        this.plotRightAxis = false;
        this.animate = true;
        this.customLeftAxisMaxValue = this.customLeftAxisMinValue = this.customRightAxisMaxValue = this.customRightAxisMinValue = null;
        if (!this.proxyQuery.axes)
            return;
        for (let i = 0; i < this.proxyQuery.axes.length; i++) {
            this.proxyQuery.axes[i].nodes = [];
        }
        this.clearQueryString();
        if (this.filters) {
            this.filters.forEach(filter => {
                if (filter && filter.resetFilters) {
                    filter.resetFilters();
                }
            });
        }
        this.clearChart();
    }
    ;
    pinChartLegend() {
        this.chartLegendPinned = !this.chartLegendPinned;
        this.chartLegendPinButtonVisible = window.isTouchDevice || !this.chartLegendPinned;
    }
    ;
    onChartLegendMouseEnter() {
        this.chartLegendPinButtonVisible = true;
        if (this.chartLegendVisible)
            return;
        if (this.chartLegendPinned)
            return;
        this.chartLegendVisible = true;
    }
    ;
    onChartLegendMouseLeave() {
        this.chartLegendPinButtonVisible = window.isTouchDevice || (this.chartLegendVisible && !this.chartLegendPinned);
        if (!this.chartLegendVisible)
            return;
        if (this.chartLegendPinned)
            return;
        this.chartLegendVisible = false;
    }
    ;
    resetZoom() {
        if (!this.autoScale) {
            this.autoScale = true;
            this.forceRerender();
            return;
        }
        if (this.chart) {
            this.chart.resetZoom();
        }
    }
    ;
    checkIfQueryIsValid(index) {
        // todo: move validation inside filter component.
        let response = { isValid: false, errorMessage: "" };
        let queries = this.query.axes || [];
        let query = queries[index];
        if (!query.systemId)
            return response;
        if (!query.measurementTypeId)
            return response;
        if (!query.startTime || !query.endTime)
            return response;
        let invalidDates = false;
        try {
            invalidDates = isNaN(Date.parse(query.startTime.toString())) || isNaN(Date.parse(query.endTime.toString()));
            if (!invalidDates) {
                query.startTime = DateHelper.convertToDate(query.startTime.toString());
                query.endTime = DateHelper.convertToDate(query.endTime.toString());
            }
        }
        catch (ex) {
            console.error(ex);
            invalidDates = true;
        }
        if (invalidDates) {
            response.errorMessage = "Please enter valid dates. Check the date input format (dd MMM yyyy). Example: 10 Aug 2023.";
            return response;
        }
        if (query.startTime >= query.endTime) {
            response.errorMessage = "Please enter valid dates. The start date must be before the end date.";
            return response;
        }
        if (this.measurementTypeRequiresNode(query, index) && (!query.nodes || !query.nodes.length)) {
            response.errorMessage = "Please select the location(s).";
            return response;
        }
        response.isValid = true;
        return response;
    }
    ;
    measurementTypeRequiresNode(query, index) {
        if (!(query === null || query === void 0 ? void 0 : query.measurementTypeId))
            return false;
        let measurementCategorySystem = 4;
        var category = this.filters[index].getMeasurementCategory();
        return category.measurementCategoryId != measurementCategorySystem;
    }
    trendFilterComponentKey(index) {
        return `trend-filter-${index}`;
    }
    ;
    unitOfMeasurement(item) {
        if (this.loginState.useImperialMeasurementSystem) {
            if (item.unitOfMeasurementCodeImperial)
                return item.unitOfMeasurementCodeImperial;
            if (item.unitOfMeasurementImperial)
                return item.unitOfMeasurementImperial;
        }
        if (item.unitOfMeasurementCode)
            return item.unitOfMeasurementCode;
        if (item.unitOfMeasurement)
            return item.unitOfMeasurement;
        return "";
    }
    ;
    measurementValueText(measurement) {
        if (!measurement || !measurement.numericValue)
            return "-";
        return `${measurement.numericValue} ${this.unitOfMeasurement(measurement)}`;
    }
    ;
    searchQuery() {
        let axesToPlot = new Array();
        let validQueries = new Array();
        if (this.plotLeftAxis)
            axesToPlot.push(0);
        if (this.plotRightAxis)
            axesToPlot.push(1);
        var firstDate = undefined;
        axesToPlot.forEach(axisIndex => {
            if (!this.proxyQuery.axes)
                return;
            let query = this.proxyQuery.axes[axisIndex];
            if (!query)
                return;
            if (query.startTime)
                query.startTime = DateHelper.convertToDate(query.startTime.toString());
            if (query.startTime && (!firstDate || firstDate > query.startTime))
                firstDate = query.startTime;
            if (query.endTime)
                query.endTime = DateHelper.convertToDate(query.endTime.toString());
            validQueries.push(query);
            // force the right axis to be rendered on the right even if we don't have a left axis
            if (axisIndex && validQueries.length == 1) {
                let fakeQuery = new GetSystemTrendChartQueryModel();
                fakeQuery.init(query);
                fakeQuery.nodes = [-1];
                validQueries.unshift(fakeQuery);
            }
        });
        if (!validQueries.length) {
            Notifier.onWarning("Please review your selection for missing or invalid fields.");
            return new GetSystemTrendChartQuery();
        }
        let query = new GetSystemTrendChartQuery({
            forFeature: Feature.TrendGraph,
            timezoneOffset: moment(firstDate).utcOffset(),
            axes: validQueries
        });
        return query;
    }
    ;
    onDatasetIdSelected(datasetIndex, ctrlKey) {
        var _a, _b, _c, _d;
        if (this.chartData == null || this.chartData.datasets == null || datasetIndex >= ((_b = (_a = this.chartData) === null || _a === void 0 ? void 0 : _a.datasets) === null || _b === void 0 ? void 0 : _b.length)) {
            return;
        }
        var dataset = this.chartData.datasets[datasetIndex];
        var legend = (_c = this.chartLegend) === null || _c === void 0 ? void 0 : _c.find(x => x.id == (dataset === null || dataset === void 0 ? void 0 : dataset.yAxisID));
        var legendItem = (_d = legend === null || legend === void 0 ? void 0 : legend.items) === null || _d === void 0 ? void 0 : _d.find(x => x.dataset.datasetId == dataset.datasetId);
        if (!legendItem) {
            return;
        }
        this.onDatasetSelected(!legendItem.selected, legendItem);
        if (ctrlKey && !this.disableExtrapolateButton)
            this.extrapolate(dataset);
    }
    onDatasetSelected(checked, item) {
        this.disableExtrapolateButton = true;
        this.highlightLine(checked, item);
        if (item.dataset) {
            var filter = this.query.axes[item.dataset.yAxisID == 'y-left' ? 0 : 1];
            if (filter.measurementTypeId == MeasurementTypeEnum.Ohmic) {
                this.disableExtrapolateButton = !checked || this.blockIdsExtrapoleted.includes(item.dataset.datasetId);
            }
        }
    }
    ;
    onDatasetShowLimits(stringStatusId, item, axisId) {
        this.displayLimits(stringStatusId, item, axisId);
    }
    ;
    highlightLine(checked, item) {
        var _a;
        if (!this.chartLegend)
            return;
        this.animate = false;
        // Get the chart instance to update datasets directly
        let chartInstance = (_a = this.chart) === null || _a === void 0 ? void 0 : _a.chartInstance;
        if (!chartInstance)
            return;
        // Update all legend items
        for (var i = 0; i < this.chartLegend.length; i++) {
            let legendItems = this.chartLegend[i].items;
            for (var j = 0; j < legendItems.length; j++) {
                let legendItem = legendItems[j];
                legendItem.selected = false;
                legendItem.dataset.borderWidth = this.defaultLineWidth;
            }
        }
        // Update the chart's actual dataset objects
        chartInstance.data.datasets.forEach((dataset) => {
            if (dataset.measurementTypeId == -1) {
                dataset.borderWidth = 2;
            }
            else {
                dataset.borderWidth = this.defaultLineWidth;
            }
        });
        // Set selected item
        item.selected = checked;
        item.dataset.borderWidth = this.defaultLineWidth * (checked ? 3 : 1);
        this.highlightedDataSetId = checked ? item.dataset.datasetId || null : null;
        // Update the specific dataset in the chart
        let targetDataset = chartInstance.data.datasets.find((ds) => ds.datasetId == item.dataset.datasetId);
        if (targetDataset) {
            targetDataset.borderWidth = this.defaultLineWidth * (checked ? 3 : 1);
        }
        // Highlight associated lines (like prediction lines)
        chartInstance.data.datasets.forEach((dataset) => {
            if (dataset.datasetId == item.dataset.datasetId && dataset !== targetDataset) {
                dataset.borderWidth = (checked ? 3 : 2);
            }
        });
        // Update the chart without animation
        chartInstance.update('none');
    }
    ;
    displayLimits(stringStatusId, item, axisId) {
        if (!this.chartLegend)
            return;
        this.animate = false;
        let index = axisId.indexOf("right") < 0 ? 0 : 1;
        for (var i = 0; i < this.chartLegend.length; i++) {
            let legendItems = this.chartLegend[i].items;
            for (var j = 0; j < legendItems.length; j++) {
                let legendItem = legendItems[j];
                legendItem.showLimits = false;
            }
        }
        let limitQuery = new GetSystemTrendChartLimitQueryModel({
            nodeId: 0,
            stringStatusId: 0
        });
        if (stringStatusId) {
            item.showLimits = true;
            limitQuery.nodeId = parseInt(item.dataset.datasetId || "");
            limitQuery.stringStatusId = stringStatusId;
        }
        if (!limitQuery.nodeId)
            limitQuery.nodeId = 0;
        let setLimitNode = () => {
            if (!this.query || !this.query.axes)
                return;
            for (var i = 0; i < this.query.axes.length; i++) {
                this.query.axes[i].limitQuery = i == index ? limitQuery : null;
                ;
                if (this.proxyQuery && this.proxyQuery.axes)
                    this.proxyQuery.axes[i] = this.query.axes[i];
            }
            ;
        };
        if (this.chart && !stringStatusId) {
            this.chartData.annotations = null;
            this.chart.hideAnnotations();
            setLimitNode();
            return;
        }
        setLimitNode();
        this.plot(index);
    }
    ;
    updateChartSettings() {
        this.animate = false;
        if (!this.autoScale) {
            let leftScaleRange = new ScaleRangeModel("y-left", this.customLeftAxisMinValue || 0, this.customLeftAxisMaxValue || 0);
            this.customLeftAxisMinValue = leftScaleRange.minValue;
            this.customLeftAxisMaxValue = leftScaleRange.maxValue;
            let rightScaleRange = new ScaleRangeModel("y-right", this.customRightAxisMinValue || 0, this.customRightAxisMaxValue || 0);
            this.customRightAxisMinValue = rightScaleRange.minValue;
            this.customRightAxisMaxValue = rightScaleRange.maxValue;
        }
        // todo: this should be informed by scales returned by the server to avoid hard-coded identifiers.
        this.scaleRanges = [];
        if (this.plotLeftAxis && this.customLeftAxisMinValue != null && this.customLeftAxisMaxValue != null)
            this.scaleRanges.push(new ScaleRangeModel("y-left", this.customLeftAxisMinValue, this.customLeftAxisMaxValue));
        if (this.plotRightAxis && this.customRightAxisMinValue != null && this.customRightAxisMaxValue != null)
            this.scaleRanges.push(new ScaleRangeModel("y-right", this.customRightAxisMinValue, this.customRightAxisMaxValue));
        this.showOrHideDataPoints();
        this.forceRerender();
        this.closeChartSettingsMenu();
    }
    ;
    closeChartSettingsMenu() {
        let dropdown = this.$refs.chartSettingsDropdown;
        dropdown.close(true);
    }
    ;
    showOrHideDataPoints() {
        var _a;
        let radius = this.showDataPoints ? this.defaultPointRadius : 0;
        (_a = this.chartData.datasets) === null || _a === void 0 ? void 0 : _a.forEach(dataSet => {
            dataSet.pointRadius = radius;
        });
    }
    ;
    getStringStates() {
        lookupsClient
            .getStringStates()
            .then(response => {
            let stringStates = (response || []).filter(state => { var _a; return ((_a = state.statusName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) != "unknown"; }).map((item) => {
                return {
                    value: item.statusId,
                    text: item.statusName || ""
                };
            });
            this.stringStates = [{ value: null, text: `No limit` }].concat(stringStates);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    getLimitStringStatus(item) {
        const placeholder = `Show limit...`;
        if (!item.showLimits)
            return placeholder;
        var limit = this.stringStates.filter(state => state.value == item.showLimitsForStringStatus)[0];
        return (limit === null || limit === void 0 ? void 0 : limit.text) || placeholder;
    }
    ;
    // computed
    get allAxesLoaded() {
        if (!this.query || !this.query.axes)
            return false;
        return this.query.axes.length == this.axes.length;
    }
    ;
    get hasData() {
        return this.chartData
            && this.chartData.datasets
            && this.chartData.datasets.length ? true : false;
    }
    ;
    // observables
    axisLoaded(index) {
        if (this.axes.indexOf(index) < 0)
            this.axes.push(index);
        if (this.axes.length == 2)
            this.loadQueryString();
    }
    ;
    measurementTypeChanged(index) {
        if (!this.scaleRanges)
            return;
        this.autoScale = true;
        this.syncAxes = false;
        try {
            this.scaleRanges.splice(index, 1);
        }
        catch (ex) {
            console.error(ex);
        }
    }
    ;
    clearAxis(index) {
        let queries = this.query.axes || [];
        let query = queries[index];
        if (query.nodes)
            query.nodes = [];
    }
    ;
    synchronizeAxes() {
        if (!this.syncAxes)
            return;
        this.customRightAxisMinValue = this.customLeftAxisMinValue;
        this.customRightAxisMaxValue = this.customLeftAxisMaxValue;
    }
    ;
    synchronizeMaxLeft() {
        if (!this.syncAxes)
            return;
        this.customLeftAxisMaxValue = this.customRightAxisMaxValue;
    }
    ;
    synchronizeMaxRight() {
        if (!this.syncAxes)
            return;
        this.customRightAxisMaxValue = this.customLeftAxisMaxValue;
    }
    ;
    synchronizeMinLeft() {
        if (!this.syncAxes)
            return;
        this.customLeftAxisMinValue = this.customRightAxisMinValue;
    }
    ;
    synchronizeMinRight() {
        if (!this.syncAxes)
            return;
        this.customRightAxisMinValue = this.customLeftAxisMinValue;
    }
    ;
    // chart
    constructScales() {
        if (!this.chartData || !this.chartData.datasets || this.chartData.datasets.length <= 0)
            return {};
        var output = {};
        var xScaleName = this.chartData.datasets[0].xAxisID;
        if (xScaleName) {
            output[xScaleName] = this.constructXAxes();
        }
        this.chartData.datasets.forEach(dataset => {
            var yScaleName = dataset.yAxisID;
            if (yScaleName) {
                output[yScaleName] = this.constructYAxes(dataset);
            }
        });
        return output;
    }
    constructXAxes() {
        let displayUnit = "day";
        let timeDisplayFormat = "DD MMM YYYY";
        if (this.chartData && this.chartData.labels) {
            if (this.chartData.displayUnit)
                displayUnit = this.chartData.displayUnit;
            if (displayUnit != "day")
                timeDisplayFormat = `${timeDisplayFormat}, HH:mm`;
        }
        return {
            id: "x-axis-0",
            type: "time",
            bounds: "ticks",
            time: {
                unit: displayUnit,
                displayFormats: {
                    day: timeDisplayFormat,
                    hour: timeDisplayFormat,
                    minute: timeDisplayFormat
                }
            },
            border: {
                display: false
            },
            ticks: {
                autoSkip: true,
                maxTicksLimit: 24, // There are 24 vertical lines on the chart, one tick (label) under each vertical line
                maxRotation: 45,
                minRotation: 45
            }
        };
    }
    ;
    getChartPaddingLeft() {
        return this.plotRightAxis ? 15 : 0;
    }
    constructYAxes(dataset) {
        return {
            id: dataset.yAxisID || "",
            type: "linear",
            position: (dataset.yAxisID || "").indexOf("right") < 0 ? "left" : "right",
            title: {
                display: true,
                text: dataset.title
            },
            border: {
                display: (dataset.yAxisID || "").indexOf("right") != -1
            }
        };
    }
    ;
    constructChartLegend() {
        let chartData = this.chartData.datasets || [];
        let legend = [];
        for (let i = 0; i < chartData.length; i++) {
            let axisId = chartData[i].yAxisID;
            if (!axisId)
                continue;
            let data = chartData[i];
            let hasItems = (data.data || []).filter(value => value != null && value != undefined).length;
            if (!hasItems)
                continue;
            let idx = ArrayHelper.findFirstIndex(legend, (item) => {
                return item.id == axisId;
            });
            let item = new SelectableDatasetModel(data);
            if (this.query && this.query.axes) {
                let axis = this.query.axes[axisId.indexOf("right") < 0 ? 0 : 1];
                if (axis) {
                    item.showLimits = axis.limitQuery
                        && axis.limitQuery.stringStatusId
                        && `${axis.limitQuery.nodeId}` == item.dataset.datasetId ? true : false;
                    if (axis.limitQuery)
                        item.showLimitsForStringStatus = axis.limitQuery.stringStatusId;
                    item.selected = this.highlightedDataSetId == item.dataset.datasetId;
                    if (item.selected)
                        item.dataset.borderWidth = this.defaultLineWidth * 3;
                }
            }
            if (idx < 0)
                legend.push({ id: axisId, items: [item] });
            else
                legend[idx].items.push(item);
        }
        this.chartLegend = legend;
    }
    ;
    onChartUpdatedEvent() {
        this.animate = true;
    }
    ;
    /** Determines if we should show the chart legend.
    ** True if legend had been pinned or activated on mouseover.
     */
    get shouldShowChartLegend() {
        return this.chartLegendVisible || this.chartLegendPinned;
    }
    ;
    exportToPdf() {
        if (this.plotLeftAxis) {
            let validation = this.checkIfQueryIsValid(0);
            if (!validation.isValid) {
                Notifier.onWarning(validation.errorMessage ? validation.errorMessage : "Please review your selection for missing or invalid fields.");
                return;
            }
        }
        if (this.plotRightAxis) {
            let validation = this.checkIfQueryIsValid(1);
            if (!validation.isValid) {
                Notifier.onWarning(validation.errorMessage ? validation.errorMessage : "Please review your selection for missing or invalid fields.");
                return;
            }
        }
        if (!this.query.axes)
            return;
        if (!this.proxyQuery.axes)
            this.proxyQuery.axes = [];
        if (this.plotLeftAxis) {
            let axis = new GetSystemTrendChartQueryModel();
            axis.init(this.query.axes[0]);
            this.proxyQuery.axes[0] = axis;
        }
        if (this.plotRightAxis) {
            let axis = new GetSystemTrendChartQueryModel();
            axis.init(this.query.axes[1]);
            this.proxyQuery.axes[1] = axis;
        }
        var datasetsSelected = [];
        if (!this.plotLeftAxis) {
            datasetsSelected.push(-1);
        }
        if (this.chartLegend) {
            this.chartLegend.forEach(legend => {
                var selected = legend.items.filter(x => x.selected);
                if (selected && selected.length > 0) {
                    var idx = legend.items.indexOf(selected[0]);
                    if (idx >= 0) {
                        datasetsSelected.push(idx);
                    }
                }
                else {
                    datasetsSelected.push(-1);
                }
            });
        }
        // Render the Chart as image
        var element = document.getElementById('trend-chart');
        let canvas = null;
        if (element != null) {
            canvas = element.toDataURL('image/png');
        }
        else {
            Notifier.onWarning("Please plot the chart first.");
            return;
        }
        this.working = true;
        let query = this.searchQuery();
        let reportQuery = new GetTrendPDFReportQuery({
            timezoneOffset: moment().utcOffset(),
            trendQuery: query,
            chartImage: canvas,
            dataSelectSelectedIndex: datasetsSelected
        });
        systemTrendClient.downloadSystemTrendAsPdf(reportQuery)
            .then(response => {
            if (!response) {
                Notifier.onWarning("Could not download report data.");
                return;
            }
            let blob = new Blob([response.data], { type: 'application/pdf;base64' });
            let url = URL.createObjectURL(blob);
            var popUp = window.open(url, '_blank');
            if (popUp == null || typeof (popUp) == 'undefined') {
                alert('Please disable your pop-up blocker and try again.');
            }
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    get chartStyles() {
        return {
            height: 'calc(100vh - 210px)'
        };
    }
    ;
    extrapolate(dataset) {
        var _a, _b;
        if (this.working)
            return;
        if (!dataset) {
            var legend = (_a = this.chartLegend) === null || _a === void 0 ? void 0 : _a.find(x => x.items.find(x => x.selected));
            var legendItem = (_b = legend === null || legend === void 0 ? void 0 : legend.items) === null || _b === void 0 ? void 0 : _b.find(x => x.selected);
            if (!legendItem)
                return;
            dataset = legendItem.dataset;
        }
        if (!dataset || this.blockIdsExtrapoleted.includes(dataset.datasetId))
            return;
        let filter = this.query.axes[dataset.yAxisID == 'y-left' ? 0 : 1];
        if (!(filter === null || filter === void 0 ? void 0 : filter.measurementTypeId) == MeasurementTypeEnum.Ohmic)
            return;
        this.working = true;
        // Set a timeout to render the loading animation
        setTimeout(() => {
            var startTime = filter.startTime ? filter.startTime = DateHelper.convertToDate(filter.startTime.toString()) : null;
            let predictionQuery = new GetBlockPredictionQuery({
                blockId: dataset.datasetId,
                startDate: startTime
            });
            systemTrendClient
                .getElementXPredictionPoints(predictionQuery)
                .then(response => {
                if (!response) {
                    Notifier.onError("Error getting Predictioin");
                    return;
                }
                this.createOhmicPredictionLine(dataset, response);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        }, 1);
    }
    createOhmicPredictionLine(dataset, blockPrediction) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (!((_b = (_a = this.chartData) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.length) > 0)
            return;
        if (!(blockPrediction === null || blockPrediction === void 0 ? void 0 : blockPrediction.blockEndOfLifePrediction)) {
            Notifier.onWarning("This block doesn't have an end of life prediction yet!");
            return;
        }
        var prediction = JSON.parse(blockPrediction.apiPrediction);
        if (!(prediction === null || prediction === void 0 ? void 0 : prediction.ohmic) || ((_c = prediction === null || prediction === void 0 ? void 0 : prediction.ohmic) === null || _c === void 0 ? void 0 : _c.length) <= 0) {
            var msg = "Prediction not found!";
            if ((prediction === null || prediction === void 0 ? void 0 : prediction.type) == "failure") {
                let reason = prediction === null || prediction === void 0 ? void 0 : prediction.message;
                let ohmicRise = (_d = prediction === null || prediction === void 0 ? void 0 : prediction.details) === null || _d === void 0 ? void 0 : _d.ohmic_rise;
                let ohmicRiseLimit = (_e = prediction === null || prediction === void 0 ? void 0 : prediction.details) === null || _e === void 0 ? void 0 : _e.required_ohmic_rise;
                msg = reason !== null && reason !== void 0 ? reason : msg;
                if (ohmicRise && ohmicRiseLimit)
                    msg += ` Current Block Ohmic Rise: ${ohmicRise} - Ohmic Rise Threshold: ${ohmicRiseLimit}`;
            }
            Notifier.onWarning(msg);
            return;
        }
        var line = new Dataset();
        let points = prediction.ohmic;
        let moment_start_date = moment(prediction.start_date) || moment(this.chartData.labels[0]);
        let start_date = moment_start_date.format("YYYY-MM-DD");
        line.data = [];
        Array(line.data).fill(null, (_f = this.chartData.labels) === null || _f === void 0 ? void 0 : _f.length);
        let lastDate = moment(this.chartData.labels[this.chartData.labels.length - 1]);
        let currentDate = start_date;
        for (var i = 0; i < points.length; i++) {
            let idx = -1;
            if (moment(currentDate) > lastDate) {
                this.chartData.labels.push(currentDate);
                idx = ((_g = this.chartData.labels) === null || _g === void 0 ? void 0 : _g.length) - 1;
            }
            else
                idx = !currentDate ? -1 : (_h = this.chartData.labels) === null || _h === void 0 ? void 0 : _h.indexOf(currentDate);
            if (idx >= 0)
                line.data[idx] = points[i];
            currentDate = moment(currentDate).add(1, 'days').format('YYYY-MM-DD');
        }
        line.datasetId = dataset.datasetId;
        line.barPercentage = 0.9;
        line.backgroundColor = Array(line.data.length).fill(dataset.borderColor);
        line.borderColor = dataset.borderColor;
        line.borderDash = [5, 10, 5];
        line.borderWidth = 2;
        line.categoryPercentage = 0.8;
        line.fill = false;
        line.ids = [];
        line.label = `Ohmic Prediction: ${dataset.label}`;
        line.lineTension = 0.15;
        line.maxBarThickness = 50;
        line.measurementTypeId = 14;
        line.pointRadius = 0;
        line.snapGaps = true;
        line.title = "Ohmic Prediction";
        line.measurementTypeId = -1;
        line.unitOfMeasurement = "µΩ";
        line.xAxisID = dataset.xAxisID;
        line.yAxisID = dataset.yAxisID;
        line.yAxisId = 'y-left';
        this.chartData.datasets.push(line);
        let eolDate = moment(blockPrediction.blockEndOfLifePrediction).format("YYYY-MM-DD");
        let eolIdx = (_j = this.chartData.labels) === null || _j === void 0 ? void 0 : _j.indexOf(eolDate);
        if (eolIdx >= 0) {
            let eolAnnotation = new Annotation({
                type: 'label',
                position: 'center',
                xValue: eolDate,
                xMax: eolDate,
                xMin: eolDate,
                value: line.data[eolIdx],
                yValue: line.data[eolIdx],
                yMin: line.data[eolIdx],
                yMax: line.data[eolIdx],
                content: "\uf067",
                yScaleID: dataset.yAxisID,
                xScaleID: dataset.xAxisID,
                color: dataset.borderColor,
                font: new AnnotationFont({
                    family: 'FontAwesome',
                    size: 20,
                    weight: 900
                })
            });
            (_k = this.chartData.annotations) === null || _k === void 0 ? void 0 : _k.push(eolAnnotation);
        }
        this.blockIdsExtrapoleted.push(dataset.datasetId);
        this.disableExtrapolateButton = true;
        this.forceRerender();
    }
    extrapolateTooltip() {
        if (this.disableExtrapolateButton)
            return "Select an ohmic line to be extrapolated";
        return "Shortcut: ctrl+click the line";
    }
    getHelpText() {
        return `<div>
				<b class="bottom10">Chart Navigation Instructions</b>
				<ul>
					<li><b>Pan:</b> Hold the <b>Ctrl</b> key and <b>drag with the left mouse button</b> to move the chart horizontally or vertically.</li>
					<li><b>Zoom: Click and drag</b> over the desired area using the <b>left mouse button</b> or <b>hover the mouse pointer over the chart</b> and use the <b>scroll wheel</b> to zoom in or out across the entire view.</b></li>
					<li><b>Adjust Axis Range: Scroll the mouse wheel</b> while hovering over the axis to expand or contract the selected axis scale.</li>
				</ul>
			</div>`;
    }
    clearQueryString() {
        try {
            this.$route.query.trendQuery = null;
            queryStringHelper.updateQueryString(null, "trendQuery");
            queryStringHelper.updateQueryString(null, "trendChart");
        }
        catch (e) {
            console.error('Error clearing Query String', e);
        }
    }
    saveQueryString(query) {
        try {
            this.clearQueryString();
            // Convert to JSON string and compress
            const jsonString = JSON.stringify(query);
            const data = new TextEncoder().encode(jsonString);
            const compressed = pako.deflate(data);
            // Convert to base64url without using Buffer
            const base64 = btoa(String.fromCharCode.apply(null, compressed));
            const base64url = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
            let queryParam = [
                { value: base64url, parameterName: "trendQuery" }
            ];
            queryStringHelper.updateQueryStrings(queryParam);
        }
        catch (e) {
            console.error('Error saving Query String', e);
        }
    }
    saveChartQueryString(chartInstance) {
        var _a, _b, _c;
        let chart = chartInstance.chart;
        try {
            var chartState = {
                x: ((_a = chart.scales['x-axis-0']) === null || _a === void 0 ? void 0 : _a.min) !== undefined ? {
                    min: chart.scales['x-axis-0'].min,
                    max: chart.scales['x-axis-0'].max
                } : null,
                yLeft: ((_b = chart.scales['y-left']) === null || _b === void 0 ? void 0 : _b.min) !== undefined ? {
                    min: chart.scales['y-left'].min,
                    max: chart.scales['y-left'].max
                } : null,
                yRight: ((_c = chart.scales['y-right']) === null || _c === void 0 ? void 0 : _c.min) !== undefined ? {
                    min: chart.scales['y-right'].min,
                    max: chart.scales['y-right'].max
                } : null
            };
            // Convert to JSON string and compress
            const jsonString = JSON.stringify(chartState);
            const data = new TextEncoder().encode(jsonString);
            const compressed = pako.deflate(data);
            // Convert to base64url without using Buffer
            const base64 = btoa(String.fromCharCode.apply(null, compressed));
            const base64url = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
            let queryParam = [
                { value: base64url, parameterName: "trendChart" }
            ];
            queryStringHelper.updateQueryStrings(queryParam);
        }
        catch (e) {
            console.error('Error saving ChartQueryString', e);
        }
    }
    loadQueryString() {
        var _a, _b;
        if (!this.$route.query.trendQuery)
            return;
        try {
            var trendQuery = this.$route.query.trendQuery;
            if (!trendQuery)
                return;
            let data = null;
            try {
                // Convert base64url to binary data
                const base64 = trendQuery.replace(/-/g, '+').replace(/_/g, '/');
                const binaryString = atob(base64);
                const compressed = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    compressed[i] = binaryString.charCodeAt(i);
                }
                // Decompress data
                const decompressed = pako.inflate(compressed);
                const jsonString = new TextDecoder().decode(decompressed);
                data = JSON.parse(jsonString);
            }
            catch (_c) {
                // fallback to use old uncompressed format
                console.warn('Error reading trendQuery - Falling back to uncompressed format', e);
                data = JSON.parse(atob(this.$route.query.trendQuery));
            }
            this.proxyQuery = GetSystemTrendChartQuery.fromJS(data);
            for (var idx = 0; idx < this.proxyQuery.axes.length; idx++) {
                let axis = this.proxyQuery.axes[idx];
                if (!axis)
                    continue;
                this.query.axes[idx] = JSON.parse(JSON.stringify(axis));
                this.query.axes[idx].startTime = new Date(axis.startTime);
                this.query.axes[idx].endTime = new Date(axis.endTime);
            }
            this.plotLeftAxis = ((_a = this.proxyQuery.axes) === null || _a === void 0 ? void 0 : _a.length) > 0;
            this.plotRightAxis = ((_b = this.proxyQuery.axes) === null || _b === void 0 ? void 0 : _b.length) > 1;
            this.search().then(() => this.loadChartQueryString());
        }
        catch (e) {
            console.error("Error reading trendQuery options", e);
            return;
        }
    }
    loadChartQueryString() {
        if (!this.$route.query.trendChart)
            return;
        try {
            var trendChartQuery = this.$route.query.trendChart;
            if (!trendChartQuery)
                return;
            let data = null;
            try {
                // Convert base64url to binary data
                const base64 = trendChartQuery.replace(/-/g, '+').replace(/_/g, '/');
                const binaryString = atob(base64);
                const compressed = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    compressed[i] = binaryString.charCodeAt(i);
                }
                // Decompress data
                const decompressed = pako.inflate(compressed);
                const jsonString = new TextDecoder().decode(decompressed);
                data = JSON.parse(jsonString);
            }
            catch (_a) {
                // fallback to use old uncompressed format
                console.warn('Error reading trendChart - Falling back to uncompressed format', e);
                data = JSON.parse(atob(trendChartQuery));
            }
            let trendChart = GetSystemTrendChartQuery.fromJS(data);
            let chart = this.chart.chartInstance;
            var setZoom = (scale, option) => {
                if (!scale || !option)
                    return;
                scale.options.min = option.min;
                scale.options.max = option.max;
            };
            setZoom(chart.scales['x-axis-0'], trendChart.x);
            setZoom(chart.scales['y-left'], trendChart.yLeft);
            setZoom(chart.scales['y-right'], trendChart.yRight);
            chart.update();
            let resetZoom = (scale) => {
                if (!scale)
                    return;
                scale.options.min = undefined;
                scale.options.max = undefined;
            };
            resetZoom(chart.scales['x-axis-0']);
            resetZoom(chart.scales['y-left']);
            resetZoom(chart.scales['y-right']);
        }
        catch (e) {
            console.error('Error reading trendChart options', e);
        }
    }
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], TrendVue.prototype, "loginState", void 0);
__decorate([
    Ref("filters"),
    __metadata("design:type", Object)
], TrendVue.prototype, "filters", void 0);
__decorate([
    Ref("chart"),
    __metadata("design:type", Object)
], TrendVue.prototype, "chart", void 0);
__decorate([
    Watch("syncAxes"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TrendVue.prototype, "synchronizeAxes", null);
TrendVue = __decorate([
    Component({
        name: "TrendVue",
        components: {
            TrendGraphVue,
            TrendGraphFilterVue,
            VerticalSplitterVue
        }
    })
], TrendVue);
export default TrendVue;
